<template>
  <div>
    <h1>403 - Forbidden</h1>
    <p>You do not have permission to access this page.</p>
    <router-link to="/">Go back to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "ForbiddenPage"
}
</script>


